import React from "react";
import { Modal } from "react-bootstrap";
import ApiService from "../../../_services/ApiService";
import IssueForm from "../../../components/shared/IssueForm";

interface StudyResourceIssueModalProps {
  show: boolean;
  onHide: () => void;
  resourceId: number | null;
  resourceName: string;
}

export default function StudyResourceIssueModal({ show, onHide, resourceId, resourceName }: StudyResourceIssueModalProps) {
  if (!resourceId) return null;

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>
          Issue — {resourceName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
        <IssueForm
          resourceId={resourceId}
          onIssue={(payload) => ApiService.issueResourceToBatches(resourceId, payload)}
          onGetHistory={() => ApiService.getResourceIssueHistory(resourceId)}
          onDelete={(issueId) => ApiService.deleteResourceIssue(resourceId, issueId)}
        />
      </Modal.Body>
    </Modal>
  );
}
